// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Briefcase,
    BriefcaseBusiness,
    BriefcaseConveyorBelt,
    BriefcaseMedical,
    BringToFront,
    Broccoli,
    Broom,
    BroomSparkles,
    Brush,
    BrushCleaning,
    Bubbles,
    Bug,
    BugOff,
    BugPlay,
    Building,
    Building2,
    Bus,
    BusFront,
    Cable,
    CableCar,
    Cake,
    CakeSlice,
    Calculator,
    Calendar,
    Calendar1,
    CalendarArrowDown,
    CalendarArrowUp,
    CalendarCheck,
    CalendarCheck2,
    CalendarClock,
    CalendarCog,
    CalendarDays,
    CalendarFold,
    CalendarHeart,
    CalendarMinus,
    CalendarMinus2,
    CalendarOff,
    CalendarPlus,
    CalendarPlus2,
    CalendarRange,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "briefcase" through "calendar-range", inclusive. */
const shard: Record<string, LucideIcon> = {
    briefcase: Briefcase,
    "briefcase-business": BriefcaseBusiness,
    "briefcase-conveyor-belt": BriefcaseConveyorBelt,
    "briefcase-medical": BriefcaseMedical,
    "bring-to-front": BringToFront,
    broccoli: Broccoli,
    broom: Broom,
    "broom-sparkles": BroomSparkles,
    brush: Brush,
    "brush-cleaning": BrushCleaning,
    bubbles: Bubbles,
    bug: Bug,
    "bug-off": BugOff,
    "bug-play": BugPlay,
    building: Building,
    "building-2": Building2,
    bus: Bus,
    "bus-front": BusFront,
    cable: Cable,
    "cable-car": CableCar,
    cake: Cake,
    "cake-slice": CakeSlice,
    calculator: Calculator,
    calendar: Calendar,
    "calendar-1": Calendar1,
    "calendar-arrow-down": CalendarArrowDown,
    "calendar-arrow-up": CalendarArrowUp,
    "calendar-check": CalendarCheck,
    "calendar-check-2": CalendarCheck2,
    "calendar-clock": CalendarClock,
    "calendar-cog": CalendarCog,
    "calendar-days": CalendarDays,
    "calendar-fold": CalendarFold,
    "calendar-heart": CalendarHeart,
    "calendar-minus": CalendarMinus,
    "calendar-minus-2": CalendarMinus2,
    "calendar-off": CalendarOff,
    "calendar-plus": CalendarPlus,
    "calendar-plus-2": CalendarPlus2,
    "calendar-range": CalendarRange,
};

export default shard;
